<template>
<div>
    <!--mountedda  getCloudApiTokens bunu çalıştır token var mı yok mu diye bak ona göre baglanti var veya yok divini çalıştır bağlantı yok ise butona tıklandıgında senkronişzasyonu başlat butonuna google driva da yetki veri çalıştır -->
    <div v-if="cloudApiTokens.length>=1" id="baglantiVar">
        <div class="col-12 w-100">
            <h5 class="modalTitle">Dosya Ekle</h5>
        </div>
        <div class="addFile px-3 py-3">
            <div class="input-group w-100">
                <div class="custom-file" style="z-index:0">
                    <input type="file" class="custom-file-input" id="inputGroupFile02" @change="changedFileInput($event)">
                    <label class="custom-file-label mb-0" for="inputGroupFile02" aria-describedby="inputGroupFileAddon02">{{inputFileName.name || "Seçili dosya yok"}}</label>
                </div>
                <div class="input-group-append">
                    <button class="btn-click mcBgDark btn-new text-white px-5" type="button" id="inputGroupFileAddon04" @click="submitFile()">Yükle</button>
                </div>
            </div>
        </div>
        <div class="col-12 w-100 mt-3 d-flex align-items-baseline">
            <h5 class="modalTitle">Ekli Dosyalar</h5>
            <!-- <v-popover class="d-inline-block mx-2" style="cursor:pointer;">
                 <i class="fa fa-info-circle tooltip-target b3 text-muted" ></i>
                    <template #popover>
                        <p><i class="fa fa-info-circle fa-3x text-muted"></i></p>
                            <p>
                                {{$ml.get('FILE_INFO')}}
                            </p>
                    </template>
            </v-popover> -->

             
            <i data-placement="bottom" class="fa fa-info-circle fileInfo text-muted mx-2" style="cursor:pointer;"></i>
            <div class="fileInfoContext px-2 py-2" >
                    <p><i class="fa fa-info-circle fa-2x text-muted"></i></p>
                    <p>
                        {{$ml.get('FILE_INFO')}}
                    </p>
            </div>

                <!-- <i v-tooltip="$ml.get('FILE_INFO')" class="fa fa-info-circle tooltip-target text-muted mx-2" style="cursor:pointer;" ></i> -->

                <!-- <i class="fa fa-info-circle text-muted mx-2 ata" style="cursor:pointer;"></i>
                <div class="hide">
                        <p><i class="fa fa-info-circle fa-3x text-muted"></i></p>
                        <p>
                            {{$ml.get('FILE_INFO')}}
                        </p>
                </div> -->
          
        </div>
        <div v-if="getFiles.length==0" class="px-3 py-2 fileList">
            <div class="d-flex align-items-center flex-column pt-5">
                <img src="../assets/no-file-icon.png" width="50px" height="55px" class="img-fluid" alt="">
                <span class="pt-2 noFile">Ekli dosya yok</span>
            </div>
        </div>
        <div v-if="getFiles.length>0" class="col-12 py-2 fileList w-100 m-0 scroll">
            <div class="row w-100 m-0 mb-1">
                <div class="col-7 fileListItemTitle px-3">Dosya Adı</div>
                <div class="col-3 fileListItemTitle">Dosya Boyutu</div>
            </div>
            <div class=" row addFile w-100 m-0 mt-2" v-for="(file,index) in getFiles" :key="index">
                <div class="col-7 fileListItem px-3 py-3 d-flex align-items-center">{{file.file_name}}</div>
                <div class="col-2 fileListItem px-3 py-3 d-flex align-items-center justify-content-center">{{setFileSize(file.file_size)}}</div>
                <div class="col-3 py-3 text-center text-sm-right">
                    <router-link target="_blank" :to="{path:'/api/showCloudFile', query:{fileId: file.$oid }}">
                    <button class="btn btn-light mr-1" data-toggle="tooltip" data-placement="top" title="İndiremediğiniz dosyalar için drive tarafında 3. parti çerezlere izin verilmesi gerekiyor ">
                        <span class="fas fa-download"></span>
                    </button>
                     </router-link>
                   
                    <button class="btn btn-light text-danger" @click="deleteFile(index,file.$oid)"> 
                        <span class="fas fa-trash-alt"></span>
                    </button>
                </div>
            </div>
        </div>
    </div> 
    <div v-if="cloudApiTokens.length<1" id="baglantiYok" class="container text-center py-5 mt-4 mb-5">
        <div>
            <img src="/static/images/google-drive-icon.png" class="img-fluid">
            <img src="/static/images/baglanti-yok.png" class="img-fluid px-2">
            <img src="/static/images/logo.png" class="img-fluid w-121">
        </div>
        <div class="d-flex flex-column align-items-center mt-4 pb-5 mb-5">
            <h6 class="noConnectionTitle pb-1">Bağlantı Hatası</h6>
            <span class="noConnectionDescription pb-3">Kayıtlara dosyalarınızı ekleyebilmek için google drive hesabınızla Minimum CRM'i senkronize edin.</span>
            <router-link tag="a"  to="/settings?tab=documentManagementSettings">
            <button class="btn-click mcBgDark btn-new text-white py-2 px-4 fileListItem text-white" >Senkronizasyonu Başlat</button>
            </router-link>
        </div>
    </div>
    <div v-if="showButton==true"  class="row justify-content-end noteBtnStyle my-3 m-0">
        <button class="btn btn-new save" @click="detailEdit()">{{$ml.get('SAVE')}}</button>
    </div>
    <!-- v-if="typeof this.dataContact != 'undefined' || typeof this.dataOrganization != 'undefined' 
     || typeof this.dataDeal != 'undefined' " -->
</div>
</template>

<script>
import Swal from 'sweetalert2'
import axios from 'axios'
import { createLogger, mapState } from 'vuex'
import {mapActions} from 'vuex'
export default {
    name:"file",
    data(){
        return{
            inputFileName:false,
            files:[],
            cloudApiTokens: [],
            googleDriveAuthLink: '',
            driveConnection:false,
            customerFileIds:[],
        }
    },
    props:[
        'activite',
        'customerFiles',
        'watchUpdated',
        'contactData',
        'organizationData',
        'showButton',
        'dataDeal',
        'contactId'
    ],
    methods:{
         calculateGoogleDriveAuthLink: function() {
            this.googleDriveAuthLink = this.baseUrl + '/getGoogleDriveAccessToken';
            
         },
         listTokens: function() {

             axios({
                 method: 'get',
                 url: '/getAllDefaultCloudApiTokens',
                 baseURL: this.baseUrl,
             }).then(response => {
              
            if(response.data.content){ 
                this.cloudApiTokens = response.data.content.tokens ;
            }
                //  this.cloudApiTokens = response.data.content.tokens ;
             }).catch(error => {
                 this.$notify({ 
                     group: 'foo',
                     type: 'error', 
                     title: this.$ml.get('ERROR'),
                     text: error
                 })
             });
         },
         getCustomerFiles(customerFileIds='',emit=false) {
             axios({
                 method: 'get',
                 url: '/listCustomerFiles',
                 baseURL: this.baseUrl,
                 params:{
                    customerFileIds:'['+customerFileIds.join(',')+']'
                }
             }).then(response => {
                //  this.customerFiles = response.data.content.files
                console.log(response);
                if(emit==true){
                    let a=response.data.content.files.map(function(file){
                        return {$oid:file._id.$oid,file_name:file.file_name,file_size:file.file_size}
                    })
                    this.$emit("showCustomerFile",a)
                }
             }).catch(error => {
                 this.$notify({
                     group: 'foo',
                     type: 'error',
                     title: this.$ml.get('ERROR'),
                     text: error
                 })
             });
         },
        deleteFile(index,fileId){
            var confirm_message = this.$ml.get('DELETE_FILE_CONFIRM')
            Swal.fire({
            title: this.$ml.get('DELETE_FILE'),
            text: confirm_message,
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: this.$ml.get('DELETE_FILE_CONFIRM_BTN_TXT'),
            cancelButtonText: this.$ml.get('CANCEL'),
            customClass:{
                icon:'custom-delete-warning',
                cancelButton:'custom-delete-cancel-button'
            },
            reverseButtons:true
            }).then((response)=>{
                // this.getFiles.splice(index, 1)
                 axios({
           method: 'POST',
           url: '/deleteCustomerFile',
           baseURL: this.baseUrl,
           data: {
             fileId: fileId
           },
        }).then(response => {
           this.file = response.data.content.files
           this.getFiles.splice(index, 1)
        }).catch(error => {
           this.$notify({
             group: 'foo',
             type: 'error',
             title: this.$ml.get('ERROR'),
             text: error
           })
        });
            }
        )},
        fileNotSelectedWarning(){
            var confirm_message = this.$ml.get('PLEASE_SELECT_AND_UPLOAD_FILES')
            Swal.fire({
            title: this.$ml.get('NO_FILE_SELECTED'),
            text: confirm_message,
            icon: "error",
            confirmButtonColor: '#d33',
            confirmButtonText:this.$ml.get('OKEY'),
            customClass:{
                icon:'custom-error-error',
            },
            reverseButtons:true
            })
        },
        changedFileInput(event){
            console.log(event);
            this.inputFileName=event.target.files[0]
            this.files.unshift(event.target.files[0])

        },
        submitFile(){
            let context=this
            if(this.inputFileName){
                let formData = new FormData();
                formData.append('myFile', this.inputFileName);
                // this.customerFiles.unshift(this.inputFileName)
                axios.post(
                    this.baseUrl + '/uploadFile',
                    formData,
                    {
                        headers: {
                            'Content-Type': 'multipart/form-data'
                        }
                    }
                ).then(function(response){
                    if(response.data.status.desc=="Sunucuda bir hata meydana geldi! Senkronizasyon Drive Tarafinda Kapali"){
                        console.log("yesss");
                       
                        Swal.fire({
                            title: "Uyarı",
                            text: "Sunucuda bir hata meydana geldi! Senkronizasyon Drive Tarafinda Kapali",
                            icon: "error",
                            confirmButtonColor: '#d33',
                            confirmButtonText:"Tamam",
                            customClass:{
                                icon:'custom-error-error',
                            },
                            reverseButtons:true
                        })
                    }
                    console.log('SUCCESS!!');
                    console.log(response);
                    console.log(response.data.status.desc);
                    console.log(context.inputFileName);
                    // context.customerFileIds.push(response.data.content)
                    console.log(context.customerFileIds);
                    context.$emit("addNewFile",{file_name:context.inputFileName.name,
                    file_size:context.inputFileName.size,
                    '$oid':response.data.content.oid})
                    // context.getCustomerFiles();
                    context.inputFileName=false  

                })
            }
           else{
               this.fileNotSelectedWarning()
           }
        },
        yonlendir(){
             this.$router.push({ path: 'settings', query: { tab: 'documentManagementSettings' } })
        },
        inputFileNameClear(){
            this.inputFileName=false
            
        },
        detailEdit(){
            if(typeof this.contactData != 'undefined'){
                console.log("aktivite detail sayfası update tıklandı")
                let dataObj={}
                let obj={}
                let url=""
                let fileIdsContact=[]
                url = "updateContact"
                dataObj["objId"]=this.contactId
                obj["customerFileIds"]=this.customerFiles
                console.log(this.customerFiles);
                for(let i=0;i<this.customerFiles.length;i++){
                    fileIdsContact[i]=this.customerFiles[i].oid
                }
                console.log(fileIdsContact);
                dataObj["updateObj"]=obj
                this.postContact(url,dataObj)
            }
            else if(typeof this.organizationData != 'undefined'){
                console.log("organizasyon detail sayfası update")
                let dataObj={}
                let obj={}
                let url=""
                url = "updateOrganization"
                dataObj["objId"]=this.organizationData._id.$oid
                obj["customerFileIds"]=this.customerFiles
                console.log(this.customerFiles);
                dataObj["updateObj"]=obj
                this.postOrganization(url,dataObj)
            }
            else if(typeof this.dataDeal != 'undefined'){
                console.log("fırsatlar detail sayfası update tıklandı")
                let dataObj={}
                let obj={}
                let url=""
                url = "updateDeal"
                dataObj["dealId"]=this.dataDeal._id.$oid
                obj["customerFileIds"]=this.customerFiles
                dataObj["dealUpdateObj"]=obj
                this.postDeal(url,dataObj)
            }
        },
        postContact(url,obj){
             
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            title: this.$ml.get('CONTACT_UPDATED'),
                            text: res.data.status.desc 
                        }) 
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        postOrganization(url,obj){  
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            text: res.data.status.desc 
                        })  
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        postDeal(url,obj){  
            axios({
                method:'POST',
                url:`/${url}`,
                baseURL: this.baseUrl,
                data: obj,
                withCredentials:true
            }).then((res)=>{
                    return res
            }).then((res)=>{
                if(!res.data.status){
                    this.$router.push('/logout')
                }
                if(res.data.status.code==0){
                        this.$notify({ 
                            group: 'foo',
                            type: 'success', 
                            text: res.data.status.desc 
                        })  
                }else{
                    this.$notify({ 
                        group: 'foo',
                        type: 'error', 
                        title: this.$ml.get('ERROR'),
                        text: res.data.status.desc 
                    })
                     
                }
            })
        },
        setFileSize(bytes){
            if      (bytes >= 1073741824) { bytes = (bytes / 1073741824).toFixed(2) + " GB"; }
            else if (bytes >= 1048576)    { bytes = (bytes / 1048576).toFixed(2) + " MB"; }
            else if (bytes >= 1024)       { bytes = (bytes / 1024).toFixed(2) + " KB"; }
            else if (bytes > 1)           { bytes = bytes + " bytes"; }
            else if (bytes == 1)          { bytes = bytes + " byte"; }
            else                          { bytes = "0 bytes"; }
            return bytes;
        }
    },
    watch:{
       'watchUpdated':function(){
           console.log(this.organizationData);
            console.log(this.editLineStatu);
        if(this.editLineStatu){
           console.log("ife girildi 9898989898");
           console.log(this.editLine);
          
           let updateCustomerFiles=this.editLine.customerFiles.val || []
            if(updateCustomerFiles.length>0){
                        for(let i=0;i<updateCustomerFiles.length;i++){
                            if(typeof updateCustomerFiles[i].$oid != 'undefined'){
                                updateCustomerFiles[i]=updateCustomerFiles[i].$oid
                            }
                            if(typeof updateCustomerFiles[i].oid != 'undefined'){
                                updateCustomerFiles[i]=updateCustomerFiles[i].oid
                            }
                        }
                        this.getCustomerFiles(updateCustomerFiles,true)
                    }
                    else{
                        this.$emit("showCustomerFile",[])
                    }
        //    this.$emit("showCustomerFile",updateCustomerFiles)
        }
        else{
            let updateCustomerFiles=[]
            if( typeof this.contactData != 'undefined'){
                updateCustomerFiles=this.contactData.customerFileIds || []
                 if(updateCustomerFiles.length>0){
                    for(let i=0;i<updateCustomerFiles.length;i++){
                        if(typeof updateCustomerFiles[i].$oid != 'undefined'){
                            updateCustomerFiles[i]=updateCustomerFiles[i].$oid
                        }
                         
                    }
                    this.getCustomerFiles(updateCustomerFiles,true)
                }
                else{
                    this.$emit("showCustomerFile",[])
                }
           }
           else if( typeof this.organizationData != 'undefined'){
                console.log("ife girildi cntactdata");
                console.log(this.organizationData );
                updateCustomerFiles=this.organizationData.customerFileIds || [] 
                console.log(updateCustomerFiles);
                if(updateCustomerFiles.length>0){
                    for(let i=0;i<updateCustomerFiles.length;i++){
                        if(typeof updateCustomerFiles[i].$oid != 'undefined'){
                            updateCustomerFiles[i]=updateCustomerFiles[i].$oid
                        }
                        if(typeof updateCustomerFiles[i].oid != 'undefined'){
                            updateCustomerFiles[i]=updateCustomerFiles[i].oid
                        }
                    }
                    this.getCustomerFiles(updateCustomerFiles,true)
                }
                else{
                    this.$emit("showCustomerFile",[])
                }
               
                console.log(updateCustomerFiles);
           }
           else if( typeof this.dataContact != 'undefined'){
                 console.log("ife girildi dataContatc");
                console.log(this.dataContact);
                updateCustomerFiles=this.dataContact.customerFileIds || []
           }
           else if( typeof this.dataDeal != 'undefined'){
                 console.log("ife girildi DataDealAtakan");
                updateCustomerFiles=this.dataDeal.customerFileIds || []
                  if(updateCustomerFiles.length>0){
                    for(let i=0;i<updateCustomerFiles.length;i++){
                        if(typeof updateCustomerFiles[i].$oid != 'undefined'){
                            updateCustomerFiles[i]=updateCustomerFiles[i].$oid
                        }
                        if(typeof updateCustomerFiles[i].oid != 'undefined'){
                            updateCustomerFiles[i]=updateCustomerFiles[i].oid
                        }
                    }
                    this.getCustomerFiles(updateCustomerFiles,true)
                }
                else{
                    this.$emit("showCustomerFile",[])
                }
           }
           else if( typeof this.dataOrganization != 'undefined'){
                 console.log("ife girildi DataDealAtakan");
                updateCustomerFiles=this.dataOrganization.customerFileIds || []
           }
            // this.$emit("showCustomerFile",updateCustomerFiles)
        }
        
       }
    },
    computed:{
         ...mapState([
            'baseUrl',
            'editLine',
            'editLineStatu'
         ]),
         getFiles(){
            return this.customerFiles
         },
       
    },
    created(){
        this.$root.$refs.file = this
    },
    mounted(){
        // if(window.location.pathname != login && window.location.pathname != signup){
        //     this.listTokens();
        // }
         this.listTokens();
         this.calculateGoogleDriveAuthLink();
        //  this.getCustomerFiles();
        this.driveConnection=true
        //  axios.get(
        //  axios.get(
        //         this.baseUrl + '/getAllDefaultCloudApiTokens'
        //      ).then(function(response){
        //          console.log(response);
        //      })
    },
  
}
</script>

<style scoped>
.modalTitle{
    color: #5b5f63 !important;
    font-size: 18px !important;
}
.custom-file-label{
    padding-left:80px;
    color: #D1D1D7;
    font-size: 14px;
    font-weight: 500;
    line-height: 24px;
    overflow: hidden;
}
.custom-file-label::after{
    left: 0;
    right: auto;
    content: "Göz At";
    border: 1px solid rgba(0, 0, 0, 0.1);
    border-radius: 4px;
    background-color: #3767a0 !important;
    cursor: pointer !important;
    color: #fff !important;
}
.fileList{
    height: 330px;
    background-color: #FAFAFA;
    border: 1px solid #E7E7E8;
    box-sizing: border-box;
    border-radius: 4px;
}
.addFile{
    background-color: #FAFAFA;
    border: 1px solid #E7E7E8;
    box-sizing: border-box;
    border-radius: 4px;
}
.w65{
    width: 61%;
}
.w121{
    max-width: 121px;
}
.noFile{
    color:#7e8187;
    font-weight: 500;
    font-size: 16px;
    line-height: 21px;
}
.fileListItem{
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #7e8187;
}
.fileListItemTitle{
    font-weight: 500;
    font-size: 14px;
    line-height: 21px;
    color: #2E323C;
}
.scroll::-webkit-scrollbar {
    display: none;
}
.scroll {
   -ms-overflow-style: none;  /* IE and Edge */
    scrollbar-width: none;  /* Firefox */
}
.scroll {
    overflow-y: scroll; /* Add the ability to scroll */
}
.noConnectionTitle{
    font-weight: bold;
    font-size: 16px;
    line-height: 21px;
    color: #2E323C;
}
.noConnectionDescription{
    font-size: 16px;
    line-height: 20px;
    color: #7e8187;
    max-width: 445px;
}
.fileInfo:hover + .fileInfoContext{
    display:block;
    position: absolute;
}
.fileInfoContext{
    display: none;
    width: 190px;
    height: 150px;
    border: 1px solid gray;
    border-radius: 4px;
    position: relative;
    top: 33px;
    z-index: 99999;
    background:#FAFAFA;
}
@media (max-width: 520px) {
    .img-fluid{
        max-width: 30%;
    }
} 

</style>
